import { render, staticRenderFns } from "./MaterialSnackbar.vue?vue&type=template&id=62c94454&scoped=true"
import script from "./MaterialSnackbar.vue?vue&type=script&lang=js"
export * from "./MaterialSnackbar.vue?vue&type=script&lang=js"
import style0 from "./MaterialSnackbar.vue?vue&type=style&index=0&id=62c94454&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62c94454",
  null
  
)

export default component.exports